import React from 'react';

export enum ButtonLoaderSize {
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
}

interface ButtonLoaderProps {
  dotCount?: number;
  size?: ButtonLoaderSize;
  ariaLabel?: string;
}

const DEFAULT_DOT_COUNT = 3;
const DEFAULT_SIZE = ButtonLoaderSize.Medium;
const DEFAULT_ARIA_LABEL = 'Loading';

const sizeClasses = {
  small: {
    container: 'p-1 gap-1',
    dot: 'w-1 h-1',
  },
  medium: {
    container: 'p-2 gap-2',
    dot: 'w-1.5 h-1.5',
  },
  large: {
    container: 'p-3 gap-3',
    dot: 'w-2 h-2',
  },
};

export const ButtonLoader: React.FC<ButtonLoaderProps> = ({
  dotCount = DEFAULT_DOT_COUNT,
  size = DEFAULT_SIZE,
  ariaLabel = DEFAULT_ARIA_LABEL,
}) => {
  const dots = Array.from({length: dotCount}, (_, index) => (
    <div
      key={`dot-${index}`}
      className={`${sizeClasses[size].dot} rounded-full bg-current animate-pulse`}
      style={{
        animationDelay: `${index * 0.1}s`,
        animationDuration: '1.2s',
        animationTimingFunction: 'ease-in-out',
        animationIterationCount: 'infinite',
      }}
    />
  ));

  return (
    <div className={`flex justify-center items-center ${sizeClasses[size].container}`.trim()} role="status" aria-label={ariaLabel}>
      {dots}
    </div>
  );
};
